import { ITextAttributes } from '../types';

export const CDIFtoQuillAttributeMapping = {
    bold: 'fontWeight',
    italic: 'fontStyle',
    strikeout: 'strikeout',
    underline: 'textDecoration',
};

export const QuilltoCDIFAttributeMapping = {
    fontWeight: 'bold',
    fontStyle: 'italic',
    strikeout: 'strikeout',
    textDecoration: 'underline',
};

export const StyleAttributes: ITextAttributes = {
    fontWeight: 'bold',
    fontStyle: 'italic',
    strikeout: true,
    textDecoration: 'underline',
};

export const DEFAULT_STYLE_VALUES: ITextAttributes = {
    fontWeight: 'normal',
    fontStyle: 'normal',
    strikeout: false,
    textDecoration: 'none',
};
